import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { clientAddTofavourite, getClientFavouriteFreelancer, clientRecentViews, getFreelancersHiresData, getRecentviews, SubmitSavedProjectByClient, getSavedProjectsByClient, InviteFreelancerByClient, GetInviteFreelancer, SendCounterOffer, GetSavedShowCases } from "../../Apis";


export const GetFreelancerHires = createAsyncThunk("GetFreelancerHires", async ({ token }, { rejectWithValue }) => {
    try {
        const response = await getFreelancersHiresData(token)
        return response
    } catch (error) {
        return rejectWithValue(error.response)
    }
})
export const SubmitClientRecentViews = createAsyncThunk("clientRecentViews", async ({ token, formData }, { rejectWithValue }) => {
    try {
        const response = await clientRecentViews(token, formData)
        return response.data
    } catch (error) {
        return rejectWithValue(error.response)
    }
})
export const SubmitClientAddTofavourite = createAsyncThunk("clientFavouriteProfile", async ({ token, id }, { rejectWithValue }) => {
    try {
        const response = await clientAddTofavourite(token, id)
        return response.data
    } catch (error) {
        return rejectWithValue(error.response)
    }
})

export const GetClientfavouriteFreelancers = createAsyncThunk("getClientFavouriteFreelancer", async (token, { rejectWithValue }) => {
    try {
        const response = await getClientFavouriteFreelancer(token)
        return response.data
    } catch (error) {
        return rejectWithValue(error.response)
    }
})
// get recnet views for client and freelancer 
export const GetRecentViews = createAsyncThunk("recentViews", async (token, { rejectWithValue }) => {
    try {
        const response = await getRecentviews(token)
        console.log("show slice file repsonse------->", response);

        return response
    } catch (error) {
        return rejectWithValue(error.response)
    }
})
export const SumitSavedProjects = createAsyncThunk("savedproject", async ({ token, project_id }, { rejectWithValue }) => {
    try {
        const response = await SubmitSavedProjectByClient(token, project_id)
        return response.data
    } catch (error) {
        return rejectWithValue(error.response)
    }
})
export const getClientSavedProjects = createAsyncThunk("getSavedProjects", async (token, { rejectWithValue }) => {
    try {
        const response = await getSavedProjectsByClient(token)
        return response.data
    } catch (error) {
        return rejectWithValue(error.response)
    }
})
export const inviteFreelancer = createAsyncThunk("inviteFreelancer", async ({ token, project_id, freelancer_id }, { rejectWithValue }) => {
    try {
        const response = await InviteFreelancerByClient(token, project_id, freelancer_id)
        return response
    } catch (error) {
        return rejectWithValue(error.response)
    }
})
export const getInviteFreelancer = createAsyncThunk("getInvitefreelancer", async ({ token, formData }, { rejectWithValue }) => {
    try {
        console.log("cccconsolrr tokn and frmdata---->", token, formData);

        const response = await GetInviteFreelancer(token, formData)
        console.log("show redux tookkit freelancer invitaion--->", response);
        return response.data

    } catch (error) {
        return rejectWithValue(error.response.message)
    }
})
export const getSavedShowCase = createAsyncThunk("getSavedShowCase", async (token, { rejectWithValue }) => {
    try {
        const response = await GetSavedShowCases(token)
        return response
    } catch (error) {
        return rejectWithValue(error.response.message)
    }
})




const ClientCollectionsSlice = createSlice({
    name: 'ClientCollections',
    initialState: {
        error: null,
        success: false,
        data: [],
        recentview: [],
        addToFavourite: [],
        getFavourites: [],
        getRecentReviews: [],
        savedProject: [],
        getSavedProjects: [],
        getInviteFreelancer: [],
        getSavedShowcases: [],
        loading: false

    },
    reducers: {
        clearFreelancerHires: state => {
            state.success = false;
            state.error = null
        }
    },
    extraReducers: builder => {
        builder
            .addCase(GetFreelancerHires.pending, (state, action) => {
                state.error = null;
                state.success = false
            })
            .addCase(GetFreelancerHires.fulfilled, (state, action) => {
                state.data = action.payload;
                state.error = null;
                state.success = action.payload;
            })
            .addCase(GetFreelancerHires.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false
            })
            .addCase(SubmitClientRecentViews.pending, state => {
                state.success = false;
                state.error = null;
                state.loading = true
            })
            .addCase(SubmitClientRecentViews.fulfilled, (state, action) => {
                state.recentview = action.payload.data;
                state.success = true;
                state.error = null
            })
            .addCase(SubmitClientRecentViews.rejected, (state, action) => {
                state.success = false;
                state.error = action.error.message
            })
            .addCase(SubmitClientAddTofavourite.pending, state => {
                state.success = false;
                state.error = null;
            })
            .addCase(SubmitClientAddTofavourite.fulfilled, (state, action) => {
                state.success = true;
                state.addToFavourite = action.payload.data;
                // console.log("show response for add to favourite------>",action.payload.data);

                state.error = null;
            })
            .addCase(GetClientfavouriteFreelancers.pending, state => {
                state.success = false;
                state.error = null;
            })
            .addCase(GetClientfavouriteFreelancers.fulfilled, (state, action) => {
                state.success = true;
                state.getFavourites = action.payload.data
                // console.log("show favoritte data from slice file----->",action.payload.data.data);

                state.error = null;

            })
            .addCase(GetClientfavouriteFreelancers.rejected, (state, action) => {
                state.success = false;
                state.error = action.error.message
            })
            .addCase(GetRecentViews.pending, state => {
                state.success = false;

                state.error = null;

            })
            .addCase(GetRecentViews.fulfilled, (state, action) => {
                state.success = true;
                state.getRecentReviews = action.payload.data.data


                state.error = null
            })
            .addCase(GetRecentViews.rejected, (state, action) => {
                state.success = false;
                state.error = action.error.message
            })
            .addCase(getClientSavedProjects.pending, state => {
                state.success = false;
                state.error = null
            })
            .addCase(getClientSavedProjects.fulfilled, (state, action) => {
                state.success = true;
                state.error = null;
                state.getSavedProjects = action.payload.data
            })
            .addCase(getClientSavedProjects.rejected, (state, action) => {
                state.success = false;
                state.error = action.payload;

            })
            .addCase(inviteFreelancer.pending, state => {
                state.success = false;
                state.error = null

            })
            .addCase(inviteFreelancer.fulfilled, (state, action) => {
                state.success = true;
                state.error = null;
                state.data = action.payload
            })
            .addCase(inviteFreelancer.rejected, (state, action) => {
                state.success = false;
                state.error = action.error.message;

            })
            .addCase(getInviteFreelancer.pending, state => {
                state.success = false;
                state.error = null;

            })
            .addCase(getInviteFreelancer.fulfilled, (state, action) => {
                state.success = true;
                state.error = null;
                state.getInviteFreelancer = action.payload
                // console.log("redux state data to  show invited freelancerrr---->", action.payload);


            })
            .addCase(getInviteFreelancer.rejected, (state, action) => {
                state.success = false;
                state.error = action.payload;

            })
            .addCase(getSavedShowCase.pending, state => {
                state.success = false;
                state.error = null;
            })
            .addCase(getSavedShowCase.fulfilled, (state, action) => {
                state.success = true;
                state.getSavedShowcases = action.payload.data;
                state.error = null
            })
            .addCase(getSavedShowCase.rejected, (state, action) => {
                state.success = false;
                state.error = action.payload;

            })

    }
})

export const { clearFreelancerHires } = ClientCollectionsSlice.actions;

export default ClientCollectionsSlice.reducer;